import { useEffect, useState } from "react";
import { fetchProducts } from "../lib/api";
import ProductCard from "./ProductCard";
import { ArrowRight } from "lucide-react";

const WeaveSection = ({ onQuickView, onEdit }) => {
  const [weaves, setWeaves] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await fetchProducts({ category: "Weave", sort: "featured" });
        if (!cancelled) setWeaves(data);
      } catch {
        // silent
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!loading && weaves.length === 0) return null;

  return (
    <section
      id="weaves"
      data-testid="weave-section"
      className="mx-auto max-w-[1400px] px-5 lg:px-10 pb-16 lg:pb-24"
    >
      <div className="border-t border-border/60 pt-14 lg:pt-20">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[hsl(var(--accent))] font-medium mb-2">
              Build your own
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl leading-tight text-foreground">
              Weave human hair
            </h2>
            <div className="text-sm text-muted-foreground mt-2 max-w-xl">
              100% virgin Brazilian human hair bundles. Mix bundle counts and add an
              HD closure or frontal — all priced live.
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10">
          {weaves.map((p) => (
            <ProductCard
              key={p.id}
              product={p}
              onQuickView={onQuickView}
              onEdit={onEdit}
            />
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <a
            href="https://kays-beauty-hair.myshopify.com/collections/all"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="weave-shop-all-link"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-foreground/80 hover:text-[hsl(var(--primary))] transition-colors"
          >
            Shop all bundles on Kay's <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default WeaveSection;
